(function () {
    'use strict';

    angular.module("imApp").factory("acLedgerViewService", ['$ihttp', function ($ihttp) {
        var service = {
            getAcLedgerView: function (parms) {
                return $ihttp.post({
                    method: 2785,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();